import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ad31730")

_pushScopeId("data-v-0ad31730")
const _hoisted_1 = { class: "overflow-hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isMedia)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["q-mb-sm full-width", { 'slide-animation': !_ctx.isFirst }]
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isMediaComponent.component), {
            src: _ctx.isMediaComponent.src,
            isWidget: true,
            onLoaded: _cache[1] || (_cache[1] = e => _ctx.$emit('loaded'))
          }, null, 8, ["src"]))
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.showText)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: [{ 'slide-animation': !_ctx.isFirst }, "text"],
          id: "trigger-preview-message"
        }, _toDisplayString(_ctx.message.text), 3))
      : _createCommentVNode("", true)
  ]))
})